import React from 'react';

const LineQuery = ({ color = '#008CFF', height = '16', width = '19' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6.5C1.17 6.5 0.5 7.17 0.5 8C0.5 8.83 1.17 9.5 2 9.5C2.83 9.5 3.5 8.83 3.5 8C3.5 7.17 2.83 6.5 2 6.5ZM2 0.5C1.17 0.5 0.5 1.17 0.5 2C0.5 2.83 1.17 3.5 2 3.5C2.83 3.5 3.5 2.83 3.5 2C3.5 1.17 2.83 0.5 2 0.5ZM2 12.665C1.265 12.665 0.665 13.26 0.665 14C0.665 14.74 1.265 15.335 2 15.335C2.735 15.335 3.335 14.74 3.335 14C3.335 13.26 2.735 12.665 2 12.665ZM5 15H19V13H5V15ZM5 9H19V7H5V9ZM5 1V3H19V1H5Z"
      fill={color}
    />
  </svg>
);

export default React.memo(LineQuery);
